import deepFreeze from 'deep-freeze';

export const MODEL_NAME = Object.freeze({
  SINGULAR: 'healthcareSite',
  PLURAL: 'healthcare-sites'
});

export const FIELD_NAME = Object.freeze({
  ID: 'id',
  NAME: 'name',
  PHONE_NUMBER: 'phoneNumber',
  LOCATION_ID: 'locationId',
  LOCATION: 'location',
  STREET_1: 'street1',
  CITY: 'city',
  STATE: 'state',
  ZIP: 'zip',
});

export const SCHEMA = deepFreeze({
  title: MODEL_NAME.SINGULAR,
  type: 'object',
  properties: {
    [FIELD_NAME.ID]: {
      type: 'string'
    },
    [FIELD_NAME.NAME]: {
      type: 'string'
    },
    [FIELD_NAME.LOCATION_ID]: {
      type: 'string'
    },
    [FIELD_NAME.PHONE_NUMBER]: {
      type: 'string'
    },
    [FIELD_NAME.LOCATION]: {
      type: 'object',
      properties: {
        [FIELD_NAME.STREET_1]: {
          type: 'string'
        },
        [FIELD_NAME.CITY]: {
          type: 'string'
        },
        [FIELD_NAME.STATE]: {
          type: 'string'
        },
        [FIELD_NAME.ZIP]: {
          type: 'string'
        }
      }
    },
    [FIELD_NAME.HEALTHCARE_SITES]: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          [FIELD_NAME.STREET_1]: {
            type: 'string'
          },
          [FIELD_NAME.CITY]: {
            type: 'string'
          },
          [FIELD_NAME.STATE]: {
            type: 'string'
          },
          [FIELD_NAME.ZIP]: {
            type: 'string'
          }
        }
      }
    }
  },
  required: [
    FIELD_NAME.NAME,
    FIELD_NAME.LOCATION
  ]
});
